module.exports = __webpack_public_path__ + "static/bestpractices-860417fe488074ad49674d51cfe16e9e.mp4";